import { SALE_FILTER_TYPE_MAP } from '../../../constants/globalTypes'
import {
  DEFAULT_BRAND_OPTION_SELECT_ALL,
  SPECIFIC_BRAND
} from './BrandAnalysis'

export const GA_CLICK_ACTION = {
  TAB: 'TAB',
  CHART_SORT: 'CHART_SORT',
  BRAND_DISTRIBUTION_DROPDOWN: 'BRAND_DISTRIBUTION_DROPDOWN'
}

const GA_KEY = {
  TAB_ALL_BRAND: 'TAB_ALL_BRAND',
  TAB_SPECIFIC_BRAND: 'TAB_SPECIFIC_BRAND',
  CHART_SORT_AMOUNT: 'CHART_SORT_AMOUNT',
  CHART_SORT_COUNT: 'CHART_SORT_COUNT',
  BRAND_DISTRIBUTION_DROPDOWN: 'BRAND_DISTRIBUTION_DROPDOWN'
}

const GA_KEY_MAP = {
  [GA_KEY.TAB_ALL_BRAND]: 'brand_overviewtab',
  [GA_KEY.TAB_SPECIFIC_BRAND]: 'brand_specbrandtab',
  [GA_KEY.CHART_SORT_AMOUNT]: 'brand_overview_orderamt',
  [GA_KEY.CHART_SORT_COUNT]: 'brand_overview_ordercnt',
  [GA_KEY.BRAND_DISTRIBUTION_DROPDOWN]: 'brand_specbrand_dropdownmenu'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.TAB: {
      const map = {
        [DEFAULT_BRAND_OPTION_SELECT_ALL.value]: GA_KEY.TAB_ALL_BRAND,
        [SPECIFIC_BRAND.value]: GA_KEY.TAB_SPECIFIC_BRAND
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.CHART_SORT: {
      const map = {
        [SALE_FILTER_TYPE_MAP.AMOUNT.type]: GA_KEY.CHART_SORT_AMOUNT,
        [SALE_FILTER_TYPE_MAP.COUNT.type]: GA_KEY.CHART_SORT_COUNT
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.BRAND_DISTRIBUTION_DROPDOWN:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
